import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import ParticipantsStore from '../../../../../../../ParticipantsStore';

interface Props {
  participantsStore: ParticipantsStore;
}

const freedLicensesCount = (participantsStore: ParticipantsStore) =>
  participantsStore.checkedParticipants.reduce(
    (a, b) => a + b.resource.payload.activatedLicenseCount,
    0,
  );

function Alert({ participantsStore }: Props) {
  return (
    <div className="bg-yellow-50 border-1 border-yellow-400 rounded">
      <p className="text-sm p-3">
        <T
          kind="If you proceed the selected participants will no longer be able to access programs and collections they were previously invited to. This will return <span>{{count}} previously Activated license</span> to..."
          span={(content) => <span className="font-bold">{content}</span>}
          count={freedLicensesCount(participantsStore)}
        />
      </p>
      <p className="px-3 pb-3 text-sm">
        <T
          kind="<span>This action can only be reversed by an ExecOnline representative. Do you wish to proceed?</span>"
          span={(content) => <span className="font-bold">{content}</span>}
        />
      </p>
    </div>
  );
}

export default observer(Alert);
